<template>
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 tableOverflow">
		<CallFlowModal
			v-if="selectedSIPCapture"
			:call-id="selectedSIPCapture"
			:call-data="selectedCallData"
			@close="selectedSIPCapture = null"
		/>
		<TranscriptionModal
			v-if="selectedTranscription"
			:call-data="selectedTranscription"
			@close="selectedTranscription = null"
		/>
		<CIPFlowModal
			v-if="selectedFlow"
			:call-data="selectedFlowData"
			:completed="true"
			:readonly="true"
			:cdr-mode="true"
			@close="selectedFlow = null"
		/>
		<div class="row hideMobile">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<div class="listHeader">
					<div class="row">
						<div
							class="col-xs-12 col-sm-2"
							:class="userRoles.includes('account') ? 'col-md-3' : 'col-md-1'"
						>
							<p>A-Leg Start</p>
						</div>
						<div
							v-if="$global.hasUserRole(userRoles, 'reseller') || tenants?.length > 1"
							class="col-xs-12 col-sm-1 col-md-1 col-lg-1"
						>
							<p>Tenant</p>
						</div>
						<div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
							<p>Call From</p>
						</div>
						<div class="col-xs-12 col-sm-3 col-md-2 col-lg-2">
							<p>Call To</p>
						</div>
						<div v-if="userRoles.includes('account')" class="col-xs-12 col-sm-2 col-md-2 col-lg-1">
							<p>A-Leg Secs</p>
						</div>
						<div class="col-xs-12 col-sm-2 col-md-2 col-lg-1 hideTablet">
							<p>B-Leg Secs</p>
						</div>
						<div
							v-if="!userRoles.includes('account') || userAccounts?.length > 1"
							class="col-xs-12 col-sm-2 col-md-2 col-lg-2"
						>
							<p>Account</p>
						</div>
						<div
							v-if="!userRoles.includes('account')"
							class="col-xs-12 col-md-2 col-lg-1 hideTabletLandscape"
						>
							<p>App / Carrier</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!calls || !calls.length" class="card listItem orange">
			<div class="row content middle-sm middle-md middle-lg">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg">
						<div class="col-xs-12 mobileMargin-b20">
							<p>No calls found.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-for="call in calls" :key="call.id" class="card listItem cursor-default p-0">
			<div
				class="row content middle-sm middle-md middle-lg cursor-pointer px-[15px] py-[10px]"
				@click="toggleLegs(call)"
			>
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg">
						<div
							class="col-xs-12 col-sm-2 mb-2 sm:mb-0"
							:class="userRoles.includes('account') ? 'col-md-3' : 'col-md-1'"
						>
							<p class="font-semibold uppercase text-gray-500 sm:hidden">A-Leg Start:</p>
							<p @mouseover="createTooltip($event, $global.dateTimeFormat(call.a_start_time))">
								{{ $global.dateTimeFormat(call.a_start_time) }}
							</p>
						</div>
						<div
							v-if="$global.hasUserRole(userRoles, 'reseller') || tenants?.length > 1"
							class="col-xs-12 col-sm-1 col-md-1 col-lg-1 mb-2 sm:mb-0"
						>
							<p class="font-semibold uppercase text-gray-500 sm:hidden">Tenant:</p>
							<p @mouseover="createTooltip($event, call.tenant_name)">{{ call.tenant_name }}</p>
						</div>
						<div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 mb-2 sm:mb-0">
							<p class="font-semibold uppercase text-gray-500 sm:hidden">Call from:</p>
							<p @mouseover="createTooltip($event, call.a_call_from)">{{ call.a_call_from }}</p>
						</div>
						<div class="col-xs-12 col-sm-3 col-md-2 col-lg-2 flex w-full justify-between sm:justify-start">
							<div>
								<p class="font-semibold uppercase text-gray-500 sm:hidden">Call to:</p>
								<p @mouseover="createTooltip($event, call.call_to)">{{ call.call_to }}</p>
							</div>
							<div
								class="col-sm-1 col-md-1 col-lg-1 end-sm end-md end-lg flex items-center gap-1 sm:bottom-auto sm:hidden md:right-0"
							>
								<Dialog v-if="call.voicemail_id">
									<DialogTrigger @click.stop="toggleVoicemail(call)">
										<span
											class="fa-solid fa-voicemail mr-2 cursor-pointer text-lg text-green"
										></span>
									</DialogTrigger>
									<DialogContent>
										<DialogHeader>
											<DialogTitle>Voicemail</DialogTitle>
											<DialogDescription>
												{{ $global.dateTimeFormat(call.a_start_time) }}
											</DialogDescription>
										</DialogHeader>
										<media-player
											v-if="previewedVoicemail && previewedVoicemail.id === call.id"
											type="voicemail"
											:file="call"
										/>
									</DialogContent>
								</Dialog>
								<Dialog v-if="call.recording_id">
									<DialogTrigger @click.stop="toggleCallRecording(call)">
										<span
											class="fa-solid fa-play-circle mr-2 cursor-pointer text-lg text-green"
										></span>
									</DialogTrigger>
									<DialogContent>
										<DialogHeader>
											<DialogTitle>Call Recording</DialogTitle>
											<DialogDescription>
												{{ $global.dateTimeFormat(call.a_start_time) }}
											</DialogDescription>
										</DialogHeader>
										<media-player
											v-if="previewedRecording && previewedRecording.id === call.id"
											type="cdr"
											:file="call"
										/>
									</DialogContent>
								</Dialog>
								<dropdown-menu
									v-if="
										userRoles.includes('calldetailrecords:getsipcapture') ||
										call.transcription ||
										call.flow_history
									"
									class="dropdownTextLeft dropdownMed"
									:items="actionsMenuItems(call)"
								>
									<template #image>
										<button
											class="flex h-6 w-full flex-row items-center justify-center rounded-sm bg-blue-500 px-4 text-white hover:bg-blue-600"
											aria-label="Action Button"
											style="color: white"
										>
											<span class="m-0 flex flex-row items-center justify-center">
												<p class="flex sm:hidden lg:flex">Action</p>
												<span class="fa-light fa-chevron-down ml-2 sm:m-0 lg:ml-2"></span>
											</span>
										</button>
									</template>
								</dropdown-menu>
							</div>
						</div>
						<div v-if="userRoles.includes('account')" class="col-xs-12 col-sm-2 col-md-2 col-lg-1">
							<p>{{ call.a_duration || 0 }}</p>
						</div>
						<div class="col-xs-12 col-md-2 col-lg-1 hideTablet">
							<p>{{ call.b_billable_duration || 0 }}</p>
						</div>
						<div
							v-if="!userRoles.includes('account') || userAccounts?.length > 1"
							class="col-xs-12 col-sm-2 col-md-2 col-lg-2 hidden sm:block"
						>
							<p @mouseover="createTooltip($event, call.account_name)">
								{{ call.account_name }}
							</p>
						</div>
						<div class="absolute right-4 top-4 block max-w-[160px] sm:hidden">
							<p class="text-md text-right font-semibold uppercase text-gray-400 sm:hidden">Account</p>
							<p
								class="text-md truncate text-right"
								@mouseover="createTooltip($event, call.account_name)"
							>
								{{ call.account_name }}
							</p>
						</div>
						<div
							v-if="!userRoles.includes('account')"
							class="col-xs-12 col-md-2 col-lg-1 hideTabletLandscape overflow-hidden"
						>
							<p
								class="truncate"
								@mouseover="createTooltip($event, call.inbound_app_name || call.carrier_name)"
							>
								{{
									call.inbound_app_name
										? $global.prettyPrint(call.inbound_app_name)
										: call.carrier_name
								}}
							</p>
						</div>
						<div
							class="col-sm-1 col-md-1 col-lg-1 end-sm end-md end-lg absolute bottom-4 right-4 hidden items-center gap-1 sm:bottom-auto sm:flex md:right-0"
						>
							<Dialog v-if="call.voicemail_id">
								<DialogTrigger @click.stop="toggleVoicemail(call)">
									<span class="fa-solid fa-voicemail mr-2 cursor-pointer text-lg text-green"></span>
								</DialogTrigger>
								<DialogContent>
									<DialogHeader>
										<DialogTitle>Voicemail</DialogTitle>
										<DialogDescription>
											{{ $global.dateTimeFormat(call.a_start_time) }}
										</DialogDescription>
									</DialogHeader>
									<media-player
										v-if="previewedVoicemail && previewedVoicemail.id === call.id"
										type="voicemail"
										:file="call"
									/>
								</DialogContent>
							</Dialog>
							<Dialog v-if="call.recording_id">
								<DialogTrigger @click.stop="toggleCallRecording(call)">
									<span class="fa-solid fa-play-circle mr-2 cursor-pointer text-lg text-green"></span>
								</DialogTrigger>
								<DialogContent>
									<DialogHeader>
										<DialogTitle>Call Recording</DialogTitle>
										<DialogDescription>
											{{ $global.dateTimeFormat(call.a_start_time) }}
										</DialogDescription>
									</DialogHeader>
									<media-player
										v-if="previewedRecording && previewedRecording.id === call.id"
										type="cdr"
										:file="call"
									/>
								</DialogContent>
							</Dialog>
							<dropdown-menu
								v-if="
									userRoles.includes('calldetailrecords:getsipcapture') ||
									call.transcription ||
									call.flow_history
								"
								class="dropdownTextLeft dropdownMed"
								:items="actionsMenuItems(call)"
							>
								<template #image>
									<button
										class="flex h-6 w-full flex-row items-center justify-center rounded-sm bg-blue-500 px-4 text-white hover:bg-blue-600"
										aria-label="Action Button"
										style="color: white"
									>
										<span class="m-0 flex flex-row items-center justify-center">
											<p class="flex sm:hidden lg:flex">Action</p>
											<span class="fa-light fa-chevron-down ml-2 sm:m-0 lg:ml-2"></span>
										</span>
									</button>
								</template>
							</dropdown-menu>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="call.expanded && !call.showLoading"
				class="relative mb-2 mt-4 overflow-hidden px-4 pb-4 text-[12px]"
			>
				<div
					class="grid w-full grid-cols-1 gap-3 rounded-sm bg-blue-50 p-[15px] dark:bg-gray-950 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
				>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">A-Leg Connected</p>
						<p>{{ $global.dateTimeFormat(call.detailed.answer_time) || 'N/A' }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">A leg secs</p>
						<p>{{ Math.round(call.detailed.duration / 1000) }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">A leg connected secs</p>
						<p>{{ call.detailed.billable_duration }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">From</p>
						<p>{{ call.detailed.call_from }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">To</p>
						<p>{{ call.detailed.call_to }}</p>
					</div>
					<div
						class="cursor-pointer overflow-hidden hover:text-gray-600"
						@click="copyToClipboard(call.detailed.call_id)"
					>
						<p class="font-semibold uppercase text-gray-500">SIP Call ID</p>
						<p class="truncate">{{ call.detailed.call_id }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">A-Leg End</p>
						<p>{{ $global.dateTimeFormat(call.detailed.end_time) }}</p>
					</div>
					<div class="overflow-hidden">
						<p class="font-semibold uppercase text-gray-500">Hangup cause</p>
						<p>{{ $global.normalCase(call.detailed.hangup_cause) || call.detailed.hangup_code || '' }}</p>
					</div>
				</div>
				<div class="relative sm:pl-4">
					<div
						v-for="(b, index) in call.detailed?.b_legs"
						:key="b.id"
						class="relative ml-4 w-auto rounded-sm pt-[15px] before:absolute before:-left-3 before:top-1/2 before:block before:h-0.5 before:w-3 before:bg-blue-200 before:content-[''] sm:before:-left-6 sm:before:w-6"
					>
						<div
							v-if="index !== call.detailed.b_legs.length - 1"
							class="absolute -left-3 top-0 h-full w-0.5 bg-blue-200 sm:-left-6"
						></div>
						<div v-else class="absolute -left-3 top-0 h-1/2 w-0.5 bg-blue-200 sm:-left-6"></div>
						<div class="bg-blue-100 p-4 dark:bg-gray-900">
							<h2 class="textSml textUppercase mb-2">B leg {{ index + 1 }}</h2>
							<div class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
								<div>
									<p class="font-semibold uppercase text-gray-500">Hangup code / cause</p>
									<p>{{ b.hangup_code }} - {{ $global.normalCase(b.hangup_cause) }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">B leg Secs</p>
									<p>{{ Math.round(b.duration / 1000) }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">B leg connected Secs</p>
									<p>{{ b.billable_duration }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">Start time</p>
									<p>{{ $global.dateTimeFormat(b.start_time) }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">Connected time</p>
									<p>{{ $global.dateTimeFormat(b.answer_time) || 'n/a' }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">End time</p>
									<p>{{ $global.dateTimeFormat(b.end_time) }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">From</p>
									<p>{{ b.call_from }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">To</p>
									<p>{{ b.call_to }}</p>
								</div>
								<div v-if="!userRoles.includes('account')">
									<p class="font-semibold uppercase text-gray-500">Carrier</p>
									<p>{{ b.carrier_name }}</p>
								</div>
								<div>
									<p class="font-semibold uppercase text-gray-500">Zone Name</p>
									<p>{{ b.zone_name }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { router } from '../router'
import cdrsApi from '../scripts/calldetailrecords/calldetailrecords.api'
import CallFlowModal from '../components/CallFlowModal.vue'
import CIPFlowModal from '../components/CIPFlowModal.vue'
import TranscriptionModal from '../components/TranscriptionModal.vue'
import {
	Dialog,
	DialogTrigger,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogContent
} from '@/components/ui/dialog'

export default {
	components: {
		CallFlowModal,
		CIPFlowModal,
		TranscriptionModal,
		Dialog,
		DialogTrigger,
		DialogHeader,
		DialogTitle,
		DialogDescription,
		DialogContent
	},
	inject: ['user', 'userRoles', 'tenants', 'userAccounts'],
	props: ['calls'],
	data() {
		return {
			selectedSIPCapture: null,
			selectedCallData: null,
			selectedFlow: null,
			selectedTranscription: null,
			selectedFlowData: null,
			previewedRecording: null,
			previewedVoicemail: null
		}
	},

	methods: {
		actionsMenuItems(call) {
			const items = []

			if (this.userRoles.includes('calldetailrecords:getsipcapture'))
				items.push({
					handler: () => {
						this.showSIPCapture(call)
					},
					icon: 'fa-light fa-phone-arrow-right',
					label: 'SIP Call Flow'
				})

			if (call.flow_history)
				items.push({
					handler: () => {
						this.showFlowModal(call)
					},
					icon: 'fa-kit fa-teleflow',
					label: 'Flow Viewer'
				})

			if (call.transcription)
				items.push({
					handler: () => {
						this.showTranscription(call)
					},
					icon: 'fa-light fa-comments',
					label: 'Transcription'
				})

			if (call.teleflow_id)
				items.push({
					handler: () => {
						this.copyTeleflowLink(call)
					},
					icon: 'fa-light fa-link',
					label: 'Copy Link'
				})

			return items
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		showSIPCapture(call) {
			this.selectedSIPCapture = call.id
			this.selectedCallData = call
		},
		showTranscription(call) {
			this.selectedTranscription = call
		},
		showFlowModal(call) {
			this.selectedFlowData = {
				teleflowId: call.teleflow_id,
				flowHistory: JSON.parse(call.flow_history)
			}
			this.selectedFlow = call.id
		},
		async toggleCallRecording(call) {
			this.previewedRecording = call
		},
		async toggleVoicemail(call) {
			this.previewedVoicemail = call
		},
		async toggleLegs(call) {
			call.expanded = !call.expanded

			if (call.expanded && !call.detailed) {
				call.showLoading = true

				call.detailed = (await cdrsApi.getByIdDetailed(call.id)).data

				if (call.detailed?.b_legs?.length) {
					call.detailed.b_legs.sort((a, b) => {
						return new Date(a.createdAt) - new Date(b.createdAt)
					})
				}

				call.showLoading = false
			}
		},
		copyToClipboard(text) {
			navigator.clipboard.writeText(text).catch((err) => {
				console.error('Could not copy text: ', err)
			})
		},
		copyTeleflowLink(call) {
			const url = `${window.location.origin}/calls?teleflow_id=${call.teleflow_id}`
			this.copyToClipboard(url)
		}
	}
}
</script>
